import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const MessagePanel = ({ messages, onSendMessage, onAttachFile }) => {
  const [newMessage, setNewMessage] = useState('');

  const handleSend = () => {
    if (newMessage?.trim()) {
      onSendMessage(newMessage);
      setNewMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && !e?.shiftKey) {
      e?.preventDefault();
      handleSend();
    }
  };

  const formatTime = (date) => {
    return new Date(date)?.toLocaleTimeString('tr-TR', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {messages?.map((message) => (
          <div
            key={message?.id}
            className={`flex gap-3 ${message?.sender === 'you' ? 'flex-row-reverse' : 'flex-row'}`}
          >
            <Image
              src={message?.avatar}
              alt={message?.avatarAlt}
              className="w-8 h-8 rounded-full object-cover flex-shrink-0"
            />
            
            <div className={`flex flex-col gap-1 max-w-[70%] ${message?.sender === 'you' ? 'items-end' : 'items-start'}`}>
              <div className={`rounded-lg px-4 py-2 ${
                message?.sender === 'you' ?'bg-primary text-primary-foreground' :'bg-muted text-foreground'
              }`}>
                <p className="text-sm">{message?.content}</p>
                {message?.attachment && (
                  <div className="mt-2 p-2 bg-background/10 rounded border border-current/20">
                    <div className="flex items-center gap-2">
                      <Icon name="Paperclip" size={16} />
                      <span className="text-xs">{message?.attachment?.name}</span>
                    </div>
                  </div>
                )}
              </div>
              <span className="text-xs text-muted-foreground">{formatTime(message?.timestamp)}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="border-t border-border p-4">
        <div className="flex items-end gap-2">
          <Button
            variant="ghost"
            size="icon"
            iconName="Paperclip"
            onClick={onAttachFile}
          />
          
          <div className="flex-1">
            <Input
              type="text"
              placeholder="Mesajınızı yazın..."
              value={newMessage}
              onChange={(e) => setNewMessage(e?.target?.value)}
              onKeyPress={handleKeyPress}
            />
          </div>

          <Button
            variant="default"
            size="icon"
            iconName="Send"
            onClick={handleSend}
            disabled={!newMessage?.trim()}
          />
        </div>
      </div>
    </div>
  );
};

export default MessagePanel;